(function () {
  function initShortcodeProducts(root = document) {
    root.querySelectorAll('[data-shortcode-product]:not([data-initialized])')
      .forEach(card => {
        card.dataset.initialized = 'true';

        const variantButtons = card.querySelectorAll('[data-variant-id]');
        const image = card.querySelector('[data-product-image]');
        const price = card.querySelector('[data-product-price]');
        const comparePrice = card.querySelector('[data-product-compare]');
        const links = card.querySelectorAll('[data-product-link]');

        variantButtons.forEach(btn => {
          btn.addEventListener('click', () => {
            // active 状态
            variantButtons.forEach(b => b.classList.remove('is-active'));
            btn.classList.add('is-active');

            // 数据更新
            image.src = btn.dataset.image;
            image.srcset = btn.dataset.image;
            image.removeAttribute('sizes');
            price.textContent = btn.dataset.price;

            if (comparePrice) {
              comparePrice.textContent = btn.dataset.compare || '';
            }
            links.forEach(link => {
              link.href = btn.dataset.url;
            });
          });
        });
      });
  }

  // 首次加载
  document.addEventListener('DOMContentLoaded', () => {
    initShortcodeProducts();
  });

  // Shopify section / ajax 兼容（可选但推荐）
  document.addEventListener('shopify:section:load', e => {
    initShortcodeProducts(e.target);
  });

})();
